import { Progress, Select, Tag, Tooltip } from "antd";
import { compare_icon } from "Benchmarking/Config/CompareIcon";
import { reference_image } from "Benchmarking/Config/Icons";
import { seniority_select } from "Benchmarking/Config/SelectData";
import { numberRegex } from "Benchmarking/Config/UtilFunction";

const ItemCompareInstitution = ({
  candidateList,
  setCandidateList,
  candidateIdList,
  setCandidateIdList,
  setCandidateIndex,
  candidates,
  setCandidates,
  setOpenAdd,
  maxData,
}) => {
  const showModal = (value) => {
    setOpenAdd(true);
    setCandidateIndex(value);
  };
  const handleRemoveCandidate = (index) => {
    setCandidateIndex(-1);
    const list = candidates.filter(
      (item) => item.id !== candidateList[`${index}`].data.id
    );
    const id_list = candidateIdList.filter(
      (item) => item.id !== candidateList[`${index}`].data.id
    );
    setCandidates(list);
    setCandidateIdList(id_list);
    if (index == 0) {
      setCandidateList({ ...candidateList, 0: null });
    } else if (index == 1) {
      setCandidateList({ ...candidateList, 1: null });
    } else if (index == 2) {
      setCandidateList({ ...candidateList, 2: null });
    } else if (index == 3) {
      setCandidateList({ ...candidateList, 3: null });
    }
  };
  const onChangeDepartments = (value, index) => {
    const newList = [...candidateIdList];
    newList[index] = {
      id: candidateList[`${index}`].data.id,
      departments: value,
    };
    setCandidateIdList(newList);
    setCandidateIndex(index);
  };
  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  const tagRender = (label) => {
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 7;
    const tagElem = (
      <Tag
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
        }}
        onMouseDown={onPreventMouseDown}
      >
        {isLongTag ? `${label.slice(0, 7)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };
  const filterlabels = (index) => {
    let numFilters = 0;
    const allFilters = Object.keys(candidateList[`${index}`].filters).map(
      (key, i) => {
        const keywords_filter = candidateList[`${index}`].filters[key];
        if (keywords_filter && key != "query" && key != "seniorities") {
          return (
            <>
              {keywords_filter.map((filter) => {
                return <Tag>{filter}</Tag>;
              })}
            </>
          );
        } else if (key == "query" && keywords_filter) {
          return <Tag>{keywords_filter}</Tag>;
        } else if (key == "seniorities" && keywords_filter) {
          return (
            <>
              {keywords_filter.map((filter) => {
                return <Tag>{seniority_select[filter - 1].label}</Tag>;
              })}
            </>
          );
        }
      }
    );
    return (
      <>
        {Object.keys(candidateList[`${index}`].filters).map((key, i) => {
          const keywords_filter = candidateList[`${index}`].filters[key];
          if (keywords_filter && key != "query" && key != "seniorities") {
            return (
              <>
                {keywords_filter.map((filter) => {
                  numFilters += 1;
                  if (numFilters <= 4) {
                    return tagRender(filter);
                  }
                })}
              </>
            );
          } else if (key == "query" && keywords_filter) {
            numFilters += 1;
            if (numFilters <= 4) {
              return tagRender(keywords_filter);
            }
          } else if (key == "seniorities" && keywords_filter) {
            return (
              <>
                {keywords_filter.map((filter) => {
                  numFilters += 1;
                  if (numFilters <= 4) {
                    return tagRender(seniority_select[filter - 1].label);
                  }
                })}
              </>
            );
          }
        })}
        <Tooltip title={<div>{allFilters}</div>}>
          {numFilters > 4 && tagRender(`+${numFilters - 4}`)}
        </Tooltip>
      </>
    );
  };
  const itemCompareInstitution = (index) => {
    if (candidateList[`${index}`] !== null) {
      return (
        <div className="compare-item-filled">
          {Object.keys(candidateList[`${index}`].filters).length > 0 && (
            <div className="filters-keyword">
              <p>Filters:</p>
              {filterlabels(index)}
            </div>
          )}
          <img
            src={
              candidateList[`${index}`].data.photo_url
                ? candidateList[`${index}`].data.photo_url
                : reference_image.institution
            }
            alt=""
          />
          <p className="name">{candidateList[`${index}`].data.name}</p>
          <div className="basic-stat-institution">
            <div
              className={
                candidateList[`${index}`].data.score.no_faculties ==
                maxData.no_faculties
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                Faculty members:{" "}
                {numberRegex(candidateList[`${index}`].data.score.no_faculties)}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data.score.no_faculties /
                    maxData.no_faculties) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
            <div
              className={
                candidateList[`${index}`].data.score.average_seniority ==
                maxData.average_seniority
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                Average seniority:{" "}
                {numberRegex(
                  candidateList[`${index}`].data.score.average_seniority
                )}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data.score.average_seniority /
                    maxData.average_seniority) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
            <div
              className={
                candidateList[`${index}`].data.score.publication_count ==
                maxData.no_publications
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                Publications:{" "}
                {numberRegex(
                  candidateList[`${index}`].data.score.publication_count
                )}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data.score.publication_count /
                    maxData.no_publications) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
            <div
              className={
                candidateList[`${index}`].data.score.no_publications_per_faculty
                  .total == maxData.no_publications_per_faculty
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                Publications per faculty:{" "}
                {numberRegex(
                  candidateList[`${index}`].data.score
                    .no_publications_per_faculty.total
                )}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data.score
                    .no_publications_per_faculty.total /
                    maxData.no_publications_per_faculty) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
            <div
              className={
                candidateList[`${index}`].data.score.citation_count.total ==
                maxData.citation_count
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                Citation count:{" "}
                {numberRegex(
                  candidateList[`${index}`].data.score.citation_count.total
                )}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data.score.citation_count.total /
                    maxData.citation_count) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
            <div
              className={
                candidateList[`${index}`].data.score.citation_count_per_faculty
                  .total == maxData.citation_count_per_faculty
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                Citation count per faculty:{" "}
                {numberRegex(
                  candidateList[`${index}`].data.score
                    .citation_count_per_faculty.total
                )}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data.score
                    .citation_count_per_faculty.total /
                    maxData.citation_count_per_faculty) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
            <div
              className={
                candidateList[`${index}`].data.score["h-index"].total ==
                maxData["h-index"]
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                H-index:{" "}
                {numberRegex(
                  candidateList[`${index}`].data.score["h-index"].total
                )}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data.score["h-index"].total /
                    maxData["h-index"]) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
          </div>
          <div className="department-select">
            <Select
              className="filter-item"
              mode="multiple"
              showSearch
              placeholder="Carnegie Classification"
              optionFilterProp="children"
              onChange={(value) => onChangeDepartments(value, index)}
              filterOption={filterOption}
              options={candidateList[`${index}`].departments}
              style={{
                width: "17vw",
              }}
            />
          </div>
          <button
            onClick={() => {
              handleRemoveCandidate(index);
            }}
          >
            Remove candidate
          </button>
        </div>
      );
    } else {
      return (
        <div className="compare-item">
          <div className="icon">{compare_icon[`${index}`].icon}</div>
          <button
            onClick={() => {
              showModal();
              setCandidateIndex(index);
            }}
          >
            Add institution
          </button>
        </div>
      );
    }
  };
  return (
    <div className="compare-list">
      {Object.keys(candidateList).map((key, index) => {
        return itemCompareInstitution(key);
      })}
    </div>
  );
};

export default ItemCompareInstitution;
